// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.InfoPopup_message__0kSS- {
  width: 100%;
}

.InfoPopup_container__B1EES {
  display: flex !important;
  flex-direction: row;
  align-items: center;
}

p {
  margin-left: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/@_components/popups/InfoPopup/InfoPopup.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;AACb;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB","sourcesContent":[".message {\n  width: 100%;\n}\n\n.container {\n  display: flex !important;\n  flex-direction: row;\n  align-items: center;\n}\n\np {\n  margin-left: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"message": `InfoPopup_message__0kSS-`,
	"container": `InfoPopup_container__B1EES`
};
export default ___CSS_LOADER_EXPORT___;
